import { useInfiniteQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts";
const fetchLedger = async (pubId, userId, page, size) => {
    var _a;
    const { data } = await API.get(`/api/v1/rbzo/loyalty/${pubId}/ledger`, { params: { userId, page, size } });
    const result = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : data;
    return result;
};
export const useLoyaltyLedger = (pubId, size = 20) => {
    const { customerData } = useCustomer();
    const userId = customerData === null || customerData === void 0 ? void 0 : customerData.uuid;
    return useInfiniteQuery(["loyaltyLedger", pubId, userId, size], ({ pageParam = 0 }) => fetchLedger(pubId, userId, pageParam, size), {
        enabled: !!pubId && !!userId,
        getNextPageParam: (lastPage) => lastPage.hasMore ? lastPage.page + 1 : undefined,
    });
};
